import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  CentralLoginCreateAccountComponent
} from '@app/modules/central-login/action-pages/central-login-create-account.component';
import { CentralLoginLoginComponent } from '@app/modules/central-login/action-pages/central-login-login.component';
import { CentralLoginDashboardComponent } from '@app/modules/central-login/pages/central-login-dashboard.component';
import { AuthorizationGuard } from '@app/modules/central-login/guards/authorization-guard';
import {
  CentralLoginForgotPasswordComponent
} from '@app/modules/central-login/action-pages/central-login-forgot-password.component';
import { CentralLoginNewLoginComponent } from '@app/modules/central-login/action-pages/central-login-new-login.component';
import { CentralLoginCreateUserComponent } from '@app/modules/central-login/action-pages/central-login-create-user.component';
import { CentralLoginJoinComponent } from '@app/modules/central-login/action-pages/central-login-join.component';
import {
  CentralLoginSelectAccountComponent
} from '@app/modules/central-login/action-pages/central-login-select-account.component';
import { CentralLoginLogoutComponent } from '@app/modules/central-login/action-pages/central-login-logout.component';
import {
  CentralLoginMailVerifiedComponent
} from '@app/modules/central-login/action-pages/central-login-mail-verified.component';
import {
  CentralLoginSsoLoginComponent
} from '@app/modules/central-login/action-pages/central-login-sso-login.component';
import { CentralLoginErrorComponent } from '@app/modules/central-login/action-pages/central-login-error.component';
import {
  CentralLoginContactAdminComponent
} from '@app/modules/central-login/action-pages/central-login-contact-admin.component';
import {
  CentralLoginAccountSettingsPersonalInfoComponent
} from '@app/modules/central-login/pages/central-login-account-settings-personal-info.component';
import {
  CentralLoginAccountSettingsPreferencesComponent
} from '@app/modules/central-login/pages/central-login-account-settings-preferences.component';
import {
  CentralLoginAccountSettingsSecurityComponent
} from '@app/modules/central-login/pages/central-login-account-settings-security.component';

const centralLoginRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: '/central-login/login', pathMatch: 'full' },
      { path: 'login', component: CentralLoginLoginComponent, data: { module: 'central-login' } },
      { path: 'forgot-password', component: CentralLoginForgotPasswordComponent },
      { path: 'new-login', component: CentralLoginNewLoginComponent },
      { path: 'create-account', component: CentralLoginCreateAccountComponent },
      { path: 'e-mail-verified', component: CentralLoginMailVerifiedComponent },
      { path: 'join', component: CentralLoginJoinComponent },
      { path: 'create-user', component: CentralLoginCreateUserComponent },
      { path: 'dashboard', component: CentralLoginDashboardComponent, data: { module: 'central-login', page: 'dashboard' }, canActivate: [AuthorizationGuard] },
      { path: 'account-settings', component: CentralLoginAccountSettingsPersonalInfoComponent, data: { module: 'central-login', page: 'account-settings' }, canActivate: [AuthorizationGuard] },
      { path: 'account-settings/security', component: CentralLoginAccountSettingsSecurityComponent, data: { module: 'central-login', page: 'account-settings' }, canActivate: [AuthorizationGuard] },
      { path: 'account-settings/preferences', component: CentralLoginAccountSettingsPreferencesComponent, data: { module: 'central-login', page: 'account-settings' }, canActivate: [AuthorizationGuard], runGuardsAndResolvers: 'always' },
      { path: 'account-settings/personal-info', component: CentralLoginAccountSettingsPersonalInfoComponent, data: { module: 'central-login', page: 'account-settings' }, canActivate: [AuthorizationGuard] },
      { path: 'select-account', component: CentralLoginSelectAccountComponent, canActivate: [AuthorizationGuard]  },
      { path: 'logout', component: CentralLoginLogoutComponent },
      { path: 'sso-login', component: CentralLoginSsoLoginComponent },
      { path: 'contact-admin', component: CentralLoginContactAdminComponent },
      { path: 'error', component: CentralLoginErrorComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(centralLoginRoutes)],
  exports: [RouterModule]
})
export class CentralLoginRoutingModule {}
